// Записи журнала зон (DeliveryZoneHistoryResource) → короткие фразы для людей.

const COLOR = { green: 'зелёная', yellow: 'жёлтая', red: 'красная' }
const COLOR_TITLE = { green: 'Зелёная', yellow: 'Жёлтая', red: 'Красная' }
export const SOURCE_NAMES = { manual: 'Вручную', import: 'Импорт', jupiter: 'Юпитер', restore: 'Откат' }
const FORMAT_NAMES = { fakt: 'ФАКТ', jupiter: 'Юпитер' }

const rub = (v) => (v == null ? '—' : Number(v).toLocaleString('ru') + ' ₽')
const arrow = (a, b, fmt = (x) => x) => `${fmt(a)} → ${fmt(b)}`

function changeLines (changes, vertices, filialName) {
  const lines = []
  const c = changes || {}
  if (c.name) lines.push(`имя: «${c.name[0]}» → «${c.name[1]}»`)
  if (c.type) lines.push('цвет: ' + arrow(c.type[0], c.type[1], (x) => COLOR[x] || x))
  if (c.time) lines.push('время: ' + arrow(c.time[0], c.time[1]) + ' мин')
  if (c.min_order_price) lines.push('мин. сумма: ' + arrow(c.min_order_price[0], c.min_order_price[1], rub))
  if (c.filial_id) lines.push('филиал: ' + arrow(c.filial_id[0], c.filial_id[1], filialName))
  if (c.status) lines.push(c.status[1] ? 'зона включена' : 'зона выключена')
  if (vertices) {
    lines.push(vertices[0] === vertices[1] ? 'контур изменён' : `вершин: ${vertices[0]} → ${vertices[1]}`)
  }
  return lines
}

/**
 * @returns {{ title: string, lines: string[] }}
 */
export function describeHistory (item, filialName = (id) => '#' + id) {
  const zone = item.zoneName ? `«${item.zoneName}»` : ''
  switch (item.event) {
    case 'created': {
      const a = item.attributes || {}
      const parts = [COLOR[a.type] || a.type, a.time != null ? a.time + ' мин' : null, a.min_order_price != null ? 'от ' + rub(a.min_order_price) : null]
      if (item.vertices) parts.push('вершин ' + item.vertices[1])
      return { title: `Создана зона ${zone}`, lines: [parts.filter(Boolean).join(', ')] }
    }
    case 'updated':
      return { title: `Изменена зона ${zone}`, lines: changeLines(item.changes, item.vertices, filialName) }
    case 'deleted':
      return { title: `Удалена зона ${zone}`, lines: [] }
    case 'undeleted':
      return { title: `Восстановлена зона ${zone}`, lines: [] }
    case 'tiers': {
      const lines = Object.entries(item.tiers || {}).map(([color, t]) => {
        const parts = []
        if (t.timeMin && t.timeMin[0] !== t.timeMin[1]) parts.push(arrow(t.timeMin[0], t.timeMin[1]) + ' мин')
        if (t.minSum && t.minSum[0] !== t.minSum[1]) parts.push(arrow(t.minSum[0], t.minSum[1], rub))
        return `${COLOR_TITLE[color] || color}: ${parts.join(', ')}`
      })
      return { title: `Тарифы филиала ${filialName(item.filialId)}`, lines }
    }
    case 'import': {
      const c = item.counts || {}
      const file = item.fileName ? `«${item.fileName}»` : ''
      return {
        title: `Импорт файла ${file} (${FORMAT_NAMES[item.format] || item.format})`,
        lines: [`обновлено ${c.update || 0}, добавлено ${c.create || 0}, удалено ${c.delete || 0}, без изменений ${c.unchanged || 0}, пропущено ${c.skip || 0}`],
      }
    }
    case 'restore': {
      const c = item.counts || {}
      const line = `изменено ${c.update || 0}, восстановлено ${c.recreate || 0}, удалено ${c.delete || 0}`
      if (item.restoredImportId) {
        return { title: 'Откат импорта', lines: [line, `филиалов: ${(item.filialIds || []).length}`] }
      }
      return { title: `Откат к версии от ${historyDate(item.snapshotAt)}`, lines: [line] }
    }
    case 'jupiter_cleanup':
      return cleanupText(item, filialName)
    default:
      return { title: item.event, lines: [] }
  }
}

const CLEANUP_SHOWN = 10

// чистка Юпитера: какие зоны удалены (при выбранном филиале бэк отдаёт только его зоны)
function cleanupText (item, filialName) {
  const zones = item.deletedZones
  const duplicate = item.reason === 'duplicate'
  const title = duplicate ? 'Юпитер удалил копии зон' : 'Юпитер удалил зоны'
  const why = duplicate ? 'лишние копии одной зоны Юпитера' : 'их больше нет в базе Юпитера'
  // старая запись без списка, или её зоны с тех пор вернули - только общий счётчик
  if (!zones || !zones.length) return { title: `${title}: ${item.count}`, lines: [why] }

  const manyFilials = new Set(zones.map((z) => z.filialId)).size > 1
  const lines = zones.slice(0, CLEANUP_SHOWN).map((z) => `«${z.name}»` + (manyFilials && z.filialId ? ` - ${filialName(z.filialId)}` : ''))
  if (zones.length > CLEANUP_SHOWN) lines.push(`и ещё ${zones.length - CLEANUP_SHOWN}`)

  return { title: `${title}: ${zones.length}`, lines: [why, ...lines] }
}

export function historyDate (s) {
  if (!s) return ''
  const [d, t] = s.split(' ')
  const [y, m, day] = d.split('-')
  return `${day}.${m}.${y} ${(t || '').slice(0, 5)}`
}
